import { render, staticRenderFns } from "./VotesHistory.vue?vue&type=template&id=39ee4066&scoped=true&"
import script from "./VotesHistory.vue?vue&type=script&lang=js&"
export * from "./VotesHistory.vue?vue&type=script&lang=js&"
import style0 from "./VotesHistory.vue?vue&type=style&index=0&id=39ee4066&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ee4066",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
